import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '../../theme/Theme.js';
import { Root } from './styled.js';
import { Group } from './Group/Group.js';
import { useToggleButtonGroupContext } from './context.js';

const BaseToggleButton = React.forwardRef((_a, ref) => {
    var { onClick, selectable = true, selected = false, onSelectedChange, className } = _a, props = __rest(_a, ["onClick", "selectable", "selected", "onSelectedChange", "className"]);
    const [_selected, _setSelected] = React.useState(selected);
    React.useEffect(() => _setSelected(selected), [selected]);
    const theme = useTheme();
    const context = useToggleButtonGroupContext();
    const handleClick = React.useCallback((e) => {
        var _a;
        (_a = context === null || context === void 0 ? void 0 : context.onChange) === null || _a === void 0 ? void 0 : _a.call(context, e, e.currentTarget.value);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
        if (!selectable)
            return;
        _setSelected(prev => {
            const next = !prev;
            onSelectedChange === null || onSelectedChange === void 0 ? void 0 : onSelectedChange(next);
            return next;
        });
    }, [context, onClick, onSelectedChange, selectable]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-toggle-button', "aria-pressed": _selected }, props, { ref: ref, "$selected": selectable ? _selected : false, theme: theme, onClick: handleClick, className: ['tend-ui-toggle-button', className].filter(Boolean).join(' ') })));
});
const ToggleButton = Object.assign(BaseToggleButton, {
    displayName: 'ToggleButton',
    Group,
});

export { ToggleButton };
//# sourceMappingURL=ToggleButton.js.map
